module.exports = __webpack_public_path__ + "static/media/avataaars.c4c71a46.svg";